import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import {
    getActiveSurvey,
    getLatestRiskResult,
} from '../api/questionnaireApi';

export interface Assessment {
    risk_code: string;
    level: string;
    explanation: string;
}

export interface RiskResult {
    request_id: number;
    status: string;
    created_at: string;
    finished_at: string;
    error: string | null;
    overall_level: string;
    overall_explanation: string
    risks: Assessment[];
}

export interface QuestionnaireState {
    passed: boolean;
    data: any | null;
    loading: boolean;
    error: string | null;
    instanceId?: number;
    riskResult?: RiskResult;
    surveyId?: number;
}

// Начальное состояние
const initialState: QuestionnaireState = {
    passed: false,
    data: null,
    loading: false,
    error: null,
    instanceId: undefined,
    riskResult: undefined,
    surveyId: undefined,
};

// Асинхронный thunk: получение активного опроса
export const fetchQuestionnaire = createAsyncThunk(
    'questionnaire/fetch',
    async () => {
        return await getActiveSurvey();
    }
);

// Асинхронный thunk: получение последних сохранённых рисков
export const fetchLatestRiskResult = createAsyncThunk(
    'questionnaire/fetchLatestRiskResult',
    async () => {
        return await getLatestRiskResult();
    }
);

// Slice
const questionnaireSlice = createSlice({
    name: 'questionnaire',
    initialState,
    reducers: {
        passQuestionnaire(state) {
            state.passed = true;
        },
        setInstanceId(state, action: PayloadAction<number>) {
            state.instanceId = action.payload;
        },
        setRiskResult(state, action: PayloadAction<RiskResult>) {
            state.riskResult = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchQuestionnaire.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchQuestionnaire.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.surveyId = action.payload.survey_id;
            })
            .addCase(fetchQuestionnaire.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Ошибка загрузки опроса';
            })
            .addCase(fetchLatestRiskResult.fulfilled, (state, action) => {
                state.riskResult = action.payload;
            });
    },
});

// Экшены
export const {
    passQuestionnaire,
    setInstanceId,
    setRiskResult,
} = questionnaireSlice.actions;

// Редьюсер по умолчанию
export default questionnaireSlice.reducer;
